import { render, staticRenderFns } from "./InspectorTeamDetails.vue?vue&type=template&id=114b533b&"
import script from "./InspectorTeamDetails.vue?vue&type=script&lang=js&"
export * from "./InspectorTeamDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports